import loop1D from '../../assets/loop1-l.mp4';
import loop1M from '../../assets/loop1-s.mp4';
import narrow1 from '../../assets/ch1-n.png';
import wide1 from '../../assets/ch1-w.png';
import loop2D from '../../assets/loop2-l.mp4';
import loop2M from '../../assets/loop2-s.mp4';
import narrow2 from '../../assets/ch2-n.jpg';
import wide2 from '../../assets/ch2-w.png';
import loop3D from '../../assets/loop3-l.mp4';
import loop3M from '../../assets/loop3-s.mp4';
import static3 from '../../assets/ch3-s.png';
import loop4D from '../../assets/loop4-l.mp4';
import loop4M from '../../assets/loop4-s.mp4';
import static4 from '../../assets/ch4-s.png';

export const chapterHeaderData = [
  {
    loopD: loop1D,
    loopM: loop1M,
    narrow: narrow1,
    wide: wide1,
    images: null,
    reverse: false
  },
  {
    loopD: loop2D,
    loopM: loop2M,
    narrow: narrow2,
    wide: wide2,
    images: null,
    reverse: true
  },
  {
    loopD: loop3D,
    loopM: loop3M,
    images: static3,
    narrow: null,
    wide: null,
    reverse: false
  },
  {
    loopD: loop4D,
    loopM: loop4M,
    images: static4,
    narrow: null,
    wide: null,
    reverse: true
  }
];
